import Company from '../interfaces/Company';
import { isEnterpriseCustomer } from './pricingUpgradeRules';

/** Free tier: combined call + chat agent cap. */
export const FREE_TIER_MAX_AGENTS = 2;

function isFreeTier(company: Company | undefined): boolean {
  if (!company) return false;
  if (isEnterpriseCustomer(company)) return false;
  return (company.plan_tier ?? 'free') === 'free';
}

/**
 * Free tier: {@link FREE_TIER_MAX_AGENTS} agents total (call or chat combined).
 * agentsCount is the total number of company agents already fetched.
 */
export function shouldBlockNewCallAgent(
  company: Company | undefined,
  agentsCount: number
): boolean {
  if (!company) return false;
  if (!isFreeTier(company)) return false;
  return agentsCount >= FREE_TIER_MAX_AGENTS;
}

/** Same combined limit as {@link shouldBlockNewCallAgent}. */
export function shouldBlockNewChatAgent(
  company: Company | undefined,
  agentsCount: number
): boolean {
  if (!company) return false;
  if (!isFreeTier(company)) return false;
  return agentsCount >= FREE_TIER_MAX_AGENTS;
}
